import { render, staticRenderFns } from "./MobileApprovalReject.vue?vue&type=template&id=652efeb4&scoped=true&"
import script from "./MobileApprovalReject.vue?vue&type=script&lang=js&"
export * from "./MobileApprovalReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652efeb4",
  null
  
)

export default component.exports